import React from 'react'
import { FaStrikethrough } from 'react-icons/fa6';

const Cards = () => {
  const staticData = [
    {
      cat: "Men's Shoe",
      name: "DNK Black Sports Shoe",
      image: "https://websitedemos.net/store-04/wp-content/uploads/sites/157/2018/01/sports-shoe5.jpg"
    },
    {
      cat: "Men's Shoe",
      name: "DNK Black Sports Shoe",
      image: "https://websitedemos.net/store-04/wp-content/uploads/sites/157/2018/01/sports-shoe5.jpg"
    },
    {
      cat: "Men's Shoe",
      name: "DNK Black Sports Shoe",
      image: "https://websitedemos.net/store-04/wp-content/uploads/sites/157/2018/01/sports-shoe5.jpg"
    },
    {
      cat: "Men's Shoe",
      name: "DNK Black Sports Shoe",
      image: "https://websitedemos.net/store-04/wp-content/uploads/sites/157/2018/01/sports-shoe5.jpg"
    },
  ];

  const renderStars = (rating) => (
    <div className="text-yellow-500 text-lg mt-1">
      {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
    </div>
  );

  return (
    <div className="py-10">
      <h1 className="text-center my-6 text-3xl sm:text-4xl font-bold text-gray-800">Our Products</h1>

      {/* Responsive Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 px-4 sm:px-10 md:px-20">
        {staticData.map((item, index) => (
          <div
            key={index}
            className="rounded-2xl overflow-hidden cursor-pointer 
                       transition duration-300 transform hover:scale-105 hover:shadow-xl"
          >
            {/* Image */}
            <img
              src={item.image}
              alt={item.name}
              className="h-56 w-full object-cover"
            />

            {/* Card Content (White Background Only) */}
            <div className="bg-white p-4">
              <p className="text-sm text-gray-500 sm:text-gray-700">{item.cat}</p>
              <h3 className="font-semibold text-lg text-gray-800 mt-1">{item.name}</h3>
              {renderStars(3)}
              <p className="mt-2 text-gray-600">
                <span className="line-through text-gray-400 mr-2">₹3900</span>
                <span className="text-green-600 font-bold">₹3500/-</span>
              </p>

              {/* Button */}
              <button className="mt-4 w-full bg-black text-white py-2 rounded-lg hover:bg-gray-800 transition sm:w-auto sm:px-6 sm:py-2 sm:rounded-2xl">
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Cards
